/// <reference path='../_all.ts' />

module library {
  'use strict';

  export class LibraryDimensionService implements ILibraryDimensionService {

    public static $inject = [
      '$timeout',
      'debounce',
      '$http',
      '$rootScope',
      '$analytics',
      'pageMetaService',
      '$q',
      'CacheFactory',
    ];

    private cacheName : string = "imageDimension"; //use different cache with capacity, because we can't store anything right now.

    constructor(
      private $timeout: ng.ITimeoutService,
      private debounce: navigation.IDebounceService,
      private $http: ng.IHttpService,
      private $rootScope: ng.IRootScopeService,
      private $analytics: angulartics.IAnalyticsService,
      private pageMetaService: navigation.IPageMetaService,
      private $q: ng.IQService,
      private CacheFactory: CacheFactory.ICacheFactory
    ) {

    }
    
    
    private getOrCreateCache() : CacheFactory.ICache {
      if (!this.CacheFactory.get(this.cacheName)) {
        this.CacheFactory.createCache(this.cacheName, {
          capacity: 20, 
          storageMode: 'sessionStorage', // This cache will use `sessionStorage`.
        });
      }
      return this.CacheFactory.get(this.cacheName);
    }


    public getDimensions(revId: number): ng.IHttpPromise<XYDimensions> {
      if (revId == null) return;
      return this.$http<XYDimensions>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/PictureLibrary/GetImageDimension"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          revId: revId
        }
      }).then((response: { data: XYDimensions }) : any => {
        return response;
      })
    }

    public getPictureTemplateList(lng: string): ng.IHttpPromise<ImageTemplate[]> {
      return this.$http<ImageTemplate[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/PictureLibrary/GetPictureTemplateList"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          lng: lng
        }
      }).then((response) : ng.IHttpResponse<ImageTemplate[]> => {
        return response;
      })
    }


    public getImageURL(revisionid: number, x: number, y: number): ng.IPromise<string[]> {
      
      var cacheKey = revisionid + "-" + x + "-" + y;
      
      var deferred = this.$q.defer<string[]>();
      var dataCache : CacheFactory.ICache = this.getOrCreateCache();

      //in cache?
      if (dataCache.get(cacheKey)) {
        deferred.resolve(dataCache.get(cacheKey));
        return deferred.promise;
      }
      
      this.$http<string[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/PictureLibrary/GetImageURL"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          revisionid: revisionid,
          x: x,
          y: y
        }
      }).then((response: { data: string[] }) :any => {
        dataCache.put(cacheKey, response.data);
        deferred.resolve(response.data);
      });
      
      return deferred.promise;                          
    }
    
  }
}